import assertOkResponseCode from '../assertOkResponseCode';

function fetchProvidersDisclaimer(sourceCurrency, targetCurrency) {
  return fetch(
    `https://api.wise.com/v3/comparisons/providers?sourceCurrency=${sourceCurrency}&targetCurrency=${targetCurrency}`,
    { method: 'GET' },
  )
    .then(assertOkResponseCode)
    .then((response) => response.json());
}

export default fetchProvidersDisclaimer;
